export interface Category {
  name: string;
  slug: string;
  url: string;
  description: string;
}

export const categories: Category[] = [
  {
    name: 'Shoes',
    slug: 'shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    description: 'Trending sneakers, boots & formal footwear sourced globally',
  },
  {
    name: 'Hoodies/Sweaters',
    slug: 'hoodies-sweaters',
    url: 'https://kaspreadsheet.com/category-912-Hoodies%2FSweaters.html',
    description: 'Cozy streetwear hoodies & premium knit sweaters',
  },
  {
    name: 'T-Shirts',
    slug: 't-shirts',
    url: 'https://kaspreadsheet.com/category-913-T-Shirts.html',
    description: 'Essential cotton tees & graphic print designs',
  },
  {
    name: 'Jackets',
    slug: 'jackets',
    url: 'https://kaspreadsheet.com/category-914-Jackets.html',
    description: 'Bombers, denim jackets & weather-ready outerwear',
  },
  {
    name: 'Pants/Shorts',
    slug: 'pants-shorts',
    url: 'https://kaspreadsheet.com/category-915-Pants%2FShorts.html',
    description: 'Cargo pants, denim & casual summer shorts',
  },
  {
    name: 'Headwear',
    slug: 'headwear',
    url: 'https://kaspreadsheet.com/category-916-Headwear.html',
    description: 'Snapbacks, beanies & bucket hats for every season',
  },
  {
    name: 'Sets',
    slug: 'sets',
    url: 'https://kaspreadsheet.com/category-917-Sets.html',
    description: 'Coordinated two-piece & matching outfit collections',
  },
  {
    name: 'Underwear/Underpants',
    slug: 'underwear-underpants',
    url: 'https://kaspreadsheet.com/category-918-underwear%2Funderpants.html',
    description: 'Comfort-focused essentials & everyday basics',
  },
  {
    name: 'Jersey',
    slug: 'jersey',
    url: 'https://kaspreadsheet.com/category-919-Jersey.html',
    description: 'Sports jerseys, team kits & athletic apparel',
  },
  {
    name: 'Accessories',
    slug: 'accessories',
    url: 'https://kaspreadsheet.com/category-920-Accessories.html',
    description: 'Watches, jewelry, sunglasses & finishing touches',
  },
  {
    name: 'Bags',
    slug: 'bags',
    url: 'https://kaspreadsheet.com/category-921-Bags.html',
    description: 'Backpacks, totes & crossbody bags for daily use',
  },
  {
    name: 'Belts',
    slug: 'belts',
    url: 'https://kaspreadsheet.com/search-922/name/Bags.html',
    description: 'Premium leather belts & statement buckle designs',
  },
  {
    name: 'Perfumes',
    slug: 'perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Bags.html',
    description: 'Designer fragrances & signature scent collections',
  },
  {
    name: 'OtherStuff',
    slug: 'other-stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Bags.html',
    description: 'Unique finds, gadgets & miscellaneous treasures',
  },
];

export const featuredCategories = categories.slice(0, 6);